import { Row, Col, P } from "../../styled/globalStyles";
// import { VscLoading } from 'react-icons/vsc'; 
import { ThreeDots } from 'react-loading-icons'

export const IsLoading = () => {
  return (  
    <main className="page-content"> 
      <div className="container-fluid"> 
        <Row className="row mt-5 px-4">   
          <Col className="col-12 text-center mt-5"> 
            {/* <VscLoading size="50" style={{ marginBottom: '20px' }} /> */}
            <ThreeDots fill={"#ff9a2e"} className="x-lg-size abs center" />
            <P>Carregando</P>
          </Col>  
        </Row> 
      </div>  
    </main>   
  )
}